import React from "react";
import { ClipLoader } from "react-spinners";

const FormButtonStyle4 = ({
  text = "Get OTP",
  onClick,
  disabled = false,
  className = "",
  id = "",
  isLoading,
}) => {
  return (
    <>
      {/* Responsive width CSS */}
      <style>
        {`
          .form-button-style4 {
            width: 340px;
            padding: 14px 0;
            font-size: 16px;
            font-weight: 400;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            color:black;
            font-family: "Atkinson Hyperlegible";
            margin-left: auto;
            margin-right: auto;
          }

          @media (max-width: 340px) {
            .form-button-style4 {
              width: 300px;

            }
          }

          @media (max-width: 320px) {
            .form-button-style4 {
              width: 310px;
            }
          }
        `}
      </style>

      <button
        onClick={onClick}
        disabled={disabled}
        className={`form-button-style4 ${className}`}
        id={id}
        style={{
          background: disabled
            ? "#333"
            : "#12F280",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        {isLoading ? (
          <ClipLoader size={20} color="#FFFFFF" />
        ) : (
          <>
            {text}
            <img
              src="/assets/img/Layer_1 (10).png"
              alt="arrow"
              style={{
                width: "18px",
                height: "18px",
                objectFit: "contain",
              }}
            />
          </>
        )}
      </button>
    </>
  );
};

export default FormButtonStyle4;
